
import { STATES } from "@/components/buyingPower/steps/location/constants";

// Export the STATES array directly for reuse
export { STATES };

// Create a comprehensive cities dataset by state
export const CITIES_BY_STATE: Record<string, {id: string, name: string}[]> = {
  "AL": [
    { id: "al-1", name: "Birmingham" },
    { id: "al-2", name: "Montgomery" },
    { id: "al-3", name: "Mobile" },
    { id: "al-4", name: "Huntsville" },
    { id: "al-5", name: "Tuscaloosa" }
  ],
  "AK": [
    { id: "ak-1", name: "Anchorage" },
    { id: "ak-2", name: "Fairbanks" },
    { id: "ak-3", name: "Juneau" },
    { id: "ak-4", name: "Sitka" },
    { id: "ak-5", name: "Ketchikan" }
  ],
  "AZ": [
    { id: "az-1", name: "Phoenix" },
    { id: "az-2", name: "Tucson" },
    { id: "az-3", name: "Mesa" },
    { id: "az-4", name: "Chandler" },
    { id: "az-5", name: "Scottsdale" }
  ],
  "AR": [
    { id: "ar-1", name: "Little Rock" },
    { id: "ar-2", name: "Fort Smith" },
    { id: "ar-3", name: "Fayetteville" },
    { id: "ar-4", name: "Springdale" },
    { id: "ar-5", name: "Jonesboro" }
  ],
  "CA": [
    { id: "ca-1", name: "Los Angeles" },
    { id: "ca-2", name: "San Francisco" },
    { id: "ca-3", name: "San Diego" },
    { id: "ca-4", name: "Sacramento" },
    { id: "ca-5", name: "San Jose" },
    { id: "ca-6", name: "Fresno" },
    { id: "ca-7", name: "Oakland" },
    { id: "ca-8", name: "Long Beach" }
  ],
  "CO": [
    { id: "co-1", name: "Denver" },
    { id: "co-2", name: "Colorado Springs" },
    { id: "co-3", name: "Aurora" },
    { id: "co-4", name: "Fort Collins" },
    { id: "co-5", name: "Lakewood" }
  ],
  "CT": [
    { id: "ct-1", name: "Bridgeport" },
    { id: "ct-2", name: "New Haven" },
    { id: "ct-3", name: "Hartford" },
    { id: "ct-4", name: "Stamford" },
    { id: "ct-5", name: "Waterbury" }
  ],
  "DE": [
    { id: "de-1", name: "Wilmington" },
    { id: "de-2", name: "Dover" },
    { id: "de-3", name: "Newark" },
    { id: "de-4", name: "Middletown" },
    { id: "de-5", name: "Smyrna" }
  ],
  "FL": [
    { id: "fl-1", name: "Miami" },
    { id: "fl-2", name: "Orlando" },
    { id: "fl-3", name: "Tampa" },
    { id: "fl-4", name: "Jacksonville" },
    { id: "fl-5", name: "St. Petersburg" },
    { id: "fl-6", name: "Fort Lauderdale" },
    { id: "fl-7", name: "Tallahassee" },
    { id: "fl-8", name: "Gainesville" }
  ],
  "GA": [
    { id: "ga-1", name: "Atlanta" },
    { id: "ga-2", name: "Augusta" },
    { id: "ga-3", name: "Columbus" },
    { id: "ga-4", name: "Savannah" },
    { id: "ga-5", name: "Athens" }
  ],
  "HI": [
    { id: "hi-1", name: "Honolulu" },
    { id: "hi-2", name: "Hilo" },
    { id: "hi-3", name: "Kailua" },
    { id: "hi-4", name: "Kapolei" },
    { id: "hi-5", name: "Kaneohe" }
  ],
  "ID": [
    { id: "id-1", name: "Boise" },
    { id: "id-2", name: "Nampa" },
    { id: "id-3", name: "Meridian" },
    { id: "id-4", name: "Idaho Falls" },
    { id: "id-5", name: "Pocatello" }
  ],
  "IL": [
    { id: "il-1", name: "Chicago" },
    { id: "il-2", name: "Springfield" },
    { id: "il-3", name: "Peoria" },
    { id: "il-4", name: "Naperville" },
    { id: "il-5", name: "Rockford" }
  ],
  "IN": [
    { id: "in-1", name: "Indianapolis" },
    { id: "in-2", name: "Fort Wayne" },
    { id: "in-3", name: "Evansville" },
    { id: "in-4", name: "South Bend" },
    { id: "in-5", name: "Carmel" }
  ],
  "IA": [
    { id: "ia-1", name: "Des Moines" },
    { id: "ia-2", name: "Cedar Rapids" },
    { id: "ia-3", name: "Davenport" },
    { id: "ia-4", name: "Sioux City" },
    { id: "ia-5", name: "Iowa City" }
  ],
  "KS": [
    { id: "ks-1", name: "Wichita" },
    { id: "ks-2", name: "Overland Park" },
    { id: "ks-3", name: "Kansas City" },
    { id: "ks-4", name: "Topeka" },
    { id: "ks-5", name: "Olathe" }
  ],
  "KY": [
    { id: "ky-1", name: "Louisville" },
    { id: "ky-2", name: "Lexington" },
    { id: "ky-3", name: "Bowling Green" },
    { id: "ky-4", name: "Owensboro" },
    { id: "ky-5", name: "Covington" }
  ],
  "LA": [
    { id: "la-1", name: "New Orleans" },
    { id: "la-2", name: "Baton Rouge" },
    { id: "la-3", name: "Shreveport" },
    { id: "la-4", name: "Lafayette" },
    { id: "la-5", name: "Lake Charles" }
  ],
  "ME": [
    { id: "me-1", name: "Portland" },
    { id: "me-2", name: "Lewiston" },
    { id: "me-3", name: "Bangor" },
    { id: "me-4", name: "South Portland" },
    { id: "me-5", name: "Auburn" }
  ],
  "MD": [
    { id: "md-1", name: "Baltimore" },
    { id: "md-2", name: "Frederick" },
    { id: "md-3", name: "Rockville" },
    { id: "md-4", name: "Gaithersburg" },
    { id: "md-5", name: "Bowie" }
  ],
  "MA": [
    { id: "ma-1", name: "Boston" },
    { id: "ma-2", name: "Worcester" },
    { id: "ma-3", name: "Springfield" },
    { id: "ma-4", name: "Cambridge" },
    { id: "ma-5", name: "Lowell" }
  ],
  "MI": [
    { id: "mi-1", name: "Detroit" },
    { id: "mi-2", name: "Grand Rapids" },
    { id: "mi-3", name: "Warren" },
    { id: "mi-4", name: "Sterling Heights" },
    { id: "mi-5", name: "Ann Arbor" }
  ],
  "MN": [
    { id: "mn-1", name: "Minneapolis" },
    { id: "mn-2", name: "St. Paul" },
    { id: "mn-3", name: "Rochester" },
    { id: "mn-4", name: "Bloomington" },
    { id: "mn-5", name: "Duluth" }
  ],
  "MS": [
    { id: "ms-1", name: "Jackson" },
    { id: "ms-2", name: "Gulfport" },
    { id: "ms-3", name: "Southaven" },
    { id: "ms-4", name: "Hattiesburg" },
    { id: "ms-5", name: "Biloxi" }
  ],
  "MO": [
    { id: "mo-1", name: "Kansas City" },
    { id: "mo-2", name: "St. Louis" },
    { id: "mo-3", name: "Springfield" },
    { id: "mo-4", name: "Columbia" },
    { id: "mo-5", name: "Independence" }
  ],
  "MT": [
    { id: "mt-1", name: "Billings" },
    { id: "mt-2", name: "Missoula" },
    { id: "mt-3", name: "Great Falls" },
    { id: "mt-4", name: "Bozeman" },
    { id: "mt-5", name: "Helena" }
  ],
  "NE": [
    { id: "ne-1", name: "Omaha" },
    { id: "ne-2", name: "Lincoln" },
    { id: "ne-3", name: "Bellevue" },
    { id: "ne-4", name: "Grand Island" },
    { id: "ne-5", name: "Kearney" }
  ],
  "NV": [
    { id: "nv-1", name: "Las Vegas" },
    { id: "nv-2", name: "Henderson" },
    { id: "nv-3", name: "Reno" },
    { id: "nv-4", name: "North Las Vegas" },
    { id: "nv-5", name: "Sparks" }
  ],
  "NH": [
    { id: "nh-1", name: "Manchester" },
    { id: "nh-2", name: "Nashua" },
    { id: "nh-3", name: "Concord" },
    { id: "nh-4", name: "Derry" },
    { id: "nh-5", name: "Dover" }
  ],
  "NJ": [
    { id: "nj-1", name: "Newark" },
    { id: "nj-2", name: "Jersey City" },
    { id: "nj-3", name: "Paterson" },
    { id: "nj-4", name: "Elizabeth" },
    { id: "nj-5", name: "Trenton" }
  ],
  "NM": [
    { id: "nm-1", name: "Albuquerque" },
    { id: "nm-2", name: "Las Cruces" },
    { id: "nm-3", name: "Rio Rancho" },
    { id: "nm-4", name: "Santa Fe" },
    { id: "nm-5", name: "Roswell" }
  ],
  "NY": [
    { id: "ny-1", name: "New York City" },
    { id: "ny-2", name: "Buffalo" },
    { id: "ny-3", name: "Albany" },
    { id: "ny-4", name: "Rochester" },
    { id: "ny-5", name: "Syracuse" },
    { id: "ny-6", name: "Yonkers" },
    { id: "ny-7", name: "Brooklyn" },
    { id: "ny-8", name: "Queens" }
  ],
  "NC": [
    { id: "nc-1", name: "Charlotte" },
    { id: "nc-2", name: "Raleigh" },
    { id: "nc-3", name: "Greensboro" },
    { id: "nc-4", name: "Durham" },
    { id: "nc-5", name: "Winston-Salem" }
  ],
  "ND": [
    { id: "nd-1", name: "Fargo" },
    { id: "nd-2", name: "Bismarck" },
    { id: "nd-3", name: "Grand Forks" },
    { id: "nd-4", name: "Minot" },
    { id: "nd-5", name: "West Fargo" }
  ],
  "OH": [
    { id: "oh-1", name: "Columbus" },
    { id: "oh-2", name: "Cleveland" },
    { id: "oh-3", name: "Cincinnati" },
    { id: "oh-4", name: "Toledo" },
    { id: "oh-5", name: "Akron" }
  ],
  "OK": [
    { id: "ok-1", name: "Oklahoma City" },
    { id: "ok-2", name: "Tulsa" },
    { id: "ok-3", name: "Norman" },
    { id: "ok-4", name: "Broken Arrow" },
    { id: "ok-5", name: "Edmond" }
  ],
  "OR": [
    { id: "or-1", name: "Portland" },
    { id: "or-2", name: "Salem" },
    { id: "or-3", name: "Eugene" },
    { id: "or-4", name: "Gresham" },
    { id: "or-5", name: "Hillsboro" }
  ],
  "PA": [
    { id: "pa-1", name: "Philadelphia" },
    { id: "pa-2", name: "Pittsburgh" },
    { id: "pa-3", name: "Allentown" },
    { id: "pa-4", name: "Erie" },
    { id: "pa-5", name: "Reading" }
  ],
  "RI": [
    { id: "ri-1", name: "Providence" },
    { id: "ri-2", name: "Warwick" },
    { id: "ri-3", name: "Cranston" },
    { id: "ri-4", name: "Pawtucket" },
    { id: "ri-5", name: "East Providence" }
  ],
  "SC": [
    { id: "sc-1", name: "Columbia" },
    { id: "sc-2", name: "Charleston" },
    { id: "sc-3", name: "North Charleston" },
    { id: "sc-4", name: "Mount Pleasant" },
    { id: "sc-5", name: "Rock Hill" }
  ],
  "SD": [
    { id: "sd-1", name: "Sioux Falls" },
    { id: "sd-2", name: "Rapid City" },
    { id: "sd-3", name: "Aberdeen" },
    { id: "sd-4", name: "Brookings" },
    { id: "sd-5", name: "Watertown" }
  ],
  "TN": [
    { id: "tn-1", name: "Nashville" },
    { id: "tn-2", name: "Memphis" },
    { id: "tn-3", name: "Knoxville" },
    { id: "tn-4", name: "Chattanooga" },
    { id: "tn-5", name: "Clarksville" }
  ],
  "TX": [
    { id: "tx-1", name: "Houston" },
    { id: "tx-2", name: "Dallas" },
    { id: "tx-3", name: "Austin" },
    { id: "tx-4", name: "San Antonio" },
    { id: "tx-5", name: "Fort Worth" },
    { id: "tx-6", name: "El Paso" },
    { id: "tx-7", name: "Arlington" },
    { id: "tx-8", name: "Corpus Christi" }
  ],
  "UT": [
    { id: "ut-1", name: "Salt Lake City" },
    { id: "ut-2", name: "West Valley City" },
    { id: "ut-3", name: "Provo" },
    { id: "ut-4", name: "West Jordan" },
    { id: "ut-5", name: "Orem" }
  ],
  "VT": [
    { id: "vt-1", name: "Burlington" },
    { id: "vt-2", name: "South Burlington" },
    { id: "vt-3", name: "Rutland" },
    { id: "vt-4", name: "Essex Junction" },
    { id: "vt-5", name: "Bennington" }
  ],
  "VA": [
    { id: "va-1", name: "Virginia Beach" },
    { id: "va-2", name: "Norfolk" },
    { id: "va-3", name: "Chesapeake" },
    { id: "va-4", name: "Richmond" },
    { id: "va-5", name: "Newport News" }
  ],
  "WA": [
    { id: "wa-1", name: "Seattle" },
    { id: "wa-2", name: "Spokane" },
    { id: "wa-3", name: "Tacoma" },
    { id: "wa-4", name: "Vancouver" },
    { id: "wa-5", name: "Bellevue" }
  ],
  "WV": [
    { id: "wv-1", name: "Charleston" },
    { id: "wv-2", name: "Huntington" },
    { id: "wv-3", name: "Morgantown" },
    { id: "wv-4", name: "Parkersburg" },
    { id: "wv-5", name: "Wheeling" }
  ],
  "WI": [
    { id: "wi-1", name: "Milwaukee" },
    { id: "wi-2", name: "Madison" },
    { id: "wi-3", name: "Green Bay" },
    { id: "wi-4", name: "Kenosha" },
    { id: "wi-5", name: "Racine" }
  ],
  "WY": [
    { id: "wy-1", name: "Cheyenne" },
    { id: "wy-2", name: "Casper" },
    { id: "wy-3", name: "Laramie" },
    { id: "wy-4", name: "Gillette" },
    { id: "wy-5", name: "Rock Springs" }
  ],
  "DC": [
    { id: "dc-1", name: "Washington" }
  ]
};
